import { useEffect, useState } from 'react';

import RadioInput from '@oui/app-core/src/components/RadioInput';
import { Lead, Text } from '@oui/app-core/src/components/Text';
import { View } from '@oui/app-core/src/components/View';

/**
 * Allows user to rate how the exercise went
 */
export const RatingAfterForm = ({ onSubmit }: { onSubmit: (rating: number) => unknown }) => {
  const [value, setValue] = useState<number>();

  useEffect(() => {
    if (typeof value === 'number') {
      onSubmit(value);
    }
    // only need onSubmit when value changes
    // eslint-disable-next-line
  }, [value]);

  return (
    <View testID="RatingAfterForm" style={{ gap: 50 }}>
      <Text
        text="Please answer the following question."
        textAlign="center"
        style={{ paddingBottom: 75 }}
      />
      <Lead
        text="How did you think those 5 rounds of this exercise went for you?"
        textAlign="center"
      />
      <View>
        <RadioInput
          aria-label="How did you think those 5 rounds of this exercise went for you?"
          items={[
            { label: 'Went well and am more brave', value: 1 },
            { label: 'Went ok', value: 0 },
            { label: "Didn't go well", value: -1 },
          ]}
          value={value}
          onChangeValue={setValue}
        />
      </View>
    </View>
  );
};
